import { defineComponent as _defineComponent } from 'vue'
import type { ImpactSolutionKind } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionKindSelect',
  props: {
    value: { default: null },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: ImpactSolutionKind | null): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit }
}

})